import { get } from 'lodash'

export const getLandingPage = state => get(state, 'landingPage')
export const getDisplaySettings = state => get(state, 'displaySettings')
export const getLandingPageSubdomain = state => get(state, 'landingPage.subdomain')
